const UserStructureWithProfiles = {
    userId: "",
    name: {
      firstName: "",
      lastName: ""
    },
    imageUrl: "",
    gender: "",
    ethenic: "",
    email: "",
    password: "",
    mobileNumber: "",
    devices: [],
    dateOfBirth: "",
    address: {
      street: "",
      city: "",
      state: "",
      zipCode: "",
      country: ""
    },
    consent: {
      termsAccepted: true,
      emailMarketing: false,
      analyticsTracking: true
    },
    payAccounts: {
      paypal: "",
      stripe: ""
    },
    nProfCount: 0,
    profiles: [
      {
        profileName: "",
        profileId: "",
        profileUUID: "",
        profileImage: "",
        profileTheme: "",
      }
    ]
  };
  
  export default UserStructureWithProfiles;
  